export const NAMESPACE = 'builds-page';

export const POLLING_TIMEOUT_MS = 10000;
export const BUILD_FETCH_OFFSET = 50;

export const FAILURE_ANALYSIS_EXPERIMENT = 'web-ui-failure-analysis';

export const PERFORMANCE_DEFAULT = 'highest';
